var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPremiumContributionBx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.166 5.001h-2.5V3.335c0-.92-.748-1.667-1.667-1.667H8c-.919 0-1.666.747-1.666 1.667V5h-2.5c-.92 0-1.667.748-1.667 1.667v9.167c0 .919.748 1.666 1.667 1.666h13.333c.92 0 1.667-.747 1.667-1.666V6.668c0-.92-.748-1.667-1.667-1.667zm-3.333 1.667v9.167H7.166V6.668h6.667zm-.834-3.333V5H8V3.335h5zM3.833 6.668h1.666v9.167H3.833V6.668zm11.666 9.167V6.668h1.667v9.167H15.5z",
    fill: "#FF6C01"
  })));
}

export default SvgIconPremiumContributionBx;